import React, { useEffect, useState, useRef } from 'react';
import css from './TopbarDynamicSearch.module.css';
import { useHistory } from 'react-router-dom';
import search from './search.png';
import searchWhite from './search_white.png';
import { post } from '../../../../util/api';
import { updateDynamicSearchOptions } from './utils';

const TopbarDynamicSearch = ({ onSelect = () => {}, hideSearch }) => {
  if (hideSearch) return null;
  const [arrayOfStrings, setArrayOfStrings] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const history = useHistory();
  const wrapperRef = useRef(null); // Create a ref for the wrapper div

  useEffect(() => {
    async function fetchData() {
      const savedArray =
        typeof window !== 'undefined' && window.sessionStorage.getItem('dynamicSearchOptions');
      if (savedArray) {
        setArrayOfStrings(JSON.parse(savedArray));
      } else {
        try {
          const searchableStrings = await updateDynamicSearchOptions();
          setArrayOfStrings(searchableStrings);
        } catch (e) {}
      }
    }
    fetchData();

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOnChange = (e) => {
    setInputValue(e.target.value);
    if (!e.target.value) {
      setSuggestions([]);
      return;
    }
    const foundOptions = arrayOfStrings.filter((i) =>
      i?.toLowerCase().includes(e.target.value?.toLowerCase())
    );
    setSuggestions(foundOptions);
  };

  const sendToSearchPage = (tag) => {
    onSelect();
    setSuggestions([]);
    setInputValue(tag);
    history.push(`/s?pub_tags=has_any%3A${encodeURIComponent(tag)}`);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (suggestions[0]) {
        setInputValue(suggestions[0]);
        sendToSearchPage(suggestions[0]);
      } else {
        setInputValue(null);
        if (!e.target.value) {
          history.push(`/s`);
          return;
        }
        history.push(`/s?pub_tags=${encodeURIComponent(`has_any:${e.target.value}`)}`);
      }
    }
  };

  const quickActionButtons = false; //arrayOfStrings?.length > 3 && arrayOfStrings.slice(0, 3);
  const showSuggestions = suggestions.length > 0;
  return (
    <>
      <div className={css.wrapper} ref={wrapperRef}>
        <img src={search} className={css.searchIcon} />
        <input
          className={`${css.field} ${showSuggestions && css.roundedField}`}
          onChange={handleOnChange}
          value={inputValue}
          placeholder={'Search scans...'}
          onKeyDown={handleKeyDown}
        />
        {showSuggestions && (
          <div className={css.suggestions}>
            {suggestions.slice(0, 4).map((s) => (
              <div className={css.suggestion} onClick={() => sendToSearchPage(s)}>
                {s}
              </div>
            ))}
          </div>
        )}
      </div>
      {quickActionButtons && (
        <div className={`${css.quickActionButtons} ${suggestions.length > 0 && css.hidden}`}>
          {quickActionButtons.map((i) => (
            <div
              className={css.quickActionButton}
              onClick={() => history.push(`/s?pub_tags=has_any%3A${encodeURIComponent(i)}`)}
            >
              <img src={searchWhite} className={css.searchIconQuick} />
              {i}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default TopbarDynamicSearch;
